import React, { Component } from 'react';
import {
    Container, Segment, Header, Table, Label, Button,
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import _ from 'underscore';
import { connect } from 'react-redux';
import './style.css';
import {
    getInpatientClaims,
    getOutpatientClaims,
    getAllClaims,
    getClaimOptionsEclaim,
    updateClaimFilterOptions,
    getClaimUserPlanConfigBenefit
} from '../../actions';
import ClaimStatusLabel from '../../component/claim/claim_status_label';
import ClaimFilterRecords from '../../component/claim/claim_filter_records';

const typeOfClaimList = {
    1 : "Panel Visit",
    2 : "Inpatient Claim",
    3 : "Outpatient Claim"
};

class ClaimRecordPage extends Component {

    state = {
        direction: 'ascending',
        claimRecords: []
    }

    componentDidMount() {
        this.fetchClaims();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { claimFilterOptions, contactNoVerified } = prevProps;
        const { fromDate, toDate, filterByClaimant, filterByCompany } = this.props.claimFilterOptions;
        if (fromDate !== claimFilterOptions.fromDate || toDate !== claimFilterOptions.toDate || filterByClaimant !== claimFilterOptions.filterByClaimant || filterByCompany !== claimFilterOptions.filterByCompany || contactNoVerified !== this.props.contactNoVerified) {
            this.fetchClaims();
        }
    }
    fetchClaims() {
        const { accessToken, uuid, companies} = this.props.user;
        const companyId = this.props.claimFilterOptions.filterByCompany ? this.props.claimFilterOptions.filterByCompany : this.props.user.companies[0].companyId

        this.props.getClaimUserPlanConfigBenefit({ accessToken, companyId });
        
        this.props.getAllClaims({claimFilterOptions: this.props.claimFilterOptions, accessToken, companyId}, (result, error)=>{
            if (result) {

                // this.handleSort()
                this.sortedClaims()
            }
            if (error) {

            }
        });
        this.props.getClaimOptionsEclaim(this.props.user.accessToken, companyId);
    }
    // renderOutpatientDataRow() {
    //     return this.props.outpatientClaims.map((claim) => {
    //         const {transactionNo, submissionDate, status, providerName, benefitGroup, benefitName} = claim;
    //         return (
    //             <Table.Row key={transactionNo}>
    //                 <Table.Cell>
    //                     <Link to={`/app/claimrecords/out/${transactionNo}`}>
    //                         {transactionNo}
    //                     </Link>
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     {Moment(submissionDate, "D/MM/YYYY").format('Do MMMM YYYY')}
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     <Label image>
    //                         <img src='https://cdn4.iconfinder.com/data/icons/computer-parts/512/refresh-512.png' />
    //                         {status}
    //                     </Label>
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     {providerName}
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     Outpatient Claim ({benefitGroup} / {benefitName})
    //                 </Table.Cell>
    //             </Table.Row>
    //         );
    //     });
    // }
    // renderInpatientDataRow() {
    //     return this.props.inpatientClaims.map((claim) => {
    //         const {transactionNo, submissionDate, status, providerName} = claim;
    //         return (
    //             <Table.Row key={transactionNo}>
    //                 <Table.Cell>
    //                     <Link to={`/app/claimrecords/inp/${transactionNo}`}>
    //                         {transactionNo}
    //                     </Link>
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     {Moment(submissionDate, "D/MM/YYYY").format('Do MMMM YYYY')}
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     <Label image>
    //                         <img src='https://cdn4.iconfinder.com/data/icons/computer-parts/512/refresh-512.png' />
    //                         {status}
    //                     </Label>
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     {providerName}
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     Inpatient Claim
    //                 </Table.Cell>
    //             </Table.Row>
    //         );
    //     });
    // }

    // renderDataRow() {
    //     return this.props.claims.map((claim) => {
    //         const { _id, created, providerName } = claim;
    //         return (
    //             <Table.Row key={_id}>
    //                 <Table.Cell>
    //                     <Link to="/app/claimrecords/out">
    //                         {_id}
    //                     </Link>
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     {Moment(created).format('Do MMMM YYYY')}
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     <Label image>
    //                         <img src='https://cdn4.iconfinder.com/data/icons/computer-parts/512/refresh-512.png' />
    //                         Submitted
    //                     </Label>
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     {providerName}
    //                 </Table.Cell>
    //                 <Table.Cell>
    //                     Flex Claim
    //                 </Table.Cell>
    //             </Table.Row>
    //         );
    //     });
    // }

    handleSort (){
        const { direction } = this.state

        this.setState({
            direction: direction === 'descending' ? 'ascending' : 'descending'
        })
    }

    sortedClaims (){
        const { direction } = this.state
        var sortedClaimsListProcessing = this.props.claimsList.filter(data => data.s === "PROCESSING").sort(function(data) {
            var dateString = ''
            if (data.ad !== '') {
                dateString = data.ad
            }
            else if (data.vd !== '') {
                dateString = data.vd
            }

            var date = new Moment(dateString, "DD/MM/YYYY");

            if (direction === 'descending') {
                return date;
            }
            return -date;
        })
        var sortedClaimsListSubmitted = this.props.claimsList.filter(data => data.s !== "PROCESSING").sort(function(data) {
            var dateString = ''
            if (data.ad !== '') {
                dateString = data.ad
            }
            else if (data.vd !== '') {
                dateString = data.vd
            }

            var date = new Moment(dateString, "DD/MM/YYYY");

            if (direction === 'descending') {
                return date;
            }
            return -date;
        })
        
        sortedClaimsListSubmitted.map((record) => {
        sortedClaimsListProcessing.push(record);
    });
    console.log("check result from sortedClaimsListSubmitted", sortedClaimsListProcessing)
        return sortedClaimsListProcessing
    }

    render() {
        // var sortedClaimsList = this.state.claimRecords

        var sortedClaimsList = this.sortedClaims()

        return (
            <Container fluid>
                <Header as='h2' attached='top' block>
                    Claim Records
                </Header>
                <Segment attached>
                    <ClaimFilterRecords
                        claimFilterOptions={this.props.claimFilterOptions}
                        user={this.props.user}
                        updateClaimFilterOptions={this.props.updateClaimFilterOptions}
                    />
                </Segment>
                <Segment>
                    <Table sortable celled selectable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Reference Number</Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={this.state.direction}
                                    onClick={() => this.handleSort()}>
                                    Visit/Admission Date
                                </Table.HeaderCell>
                                <Table.HeaderCell>Status</Table.HeaderCell>
                                <Table.HeaderCell>Clinic / Hospital / Provider</Table.HeaderCell>
                                <Table.HeaderCell>Type</Table.HeaderCell>
                                <Table.HeaderCell>Chat</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {
                                _.map(sortedClaimsList, (claim) => {
                                    const {
                                        t, // 1-panel visit, 2-inpatient claim, 3-outpatient claim
                                        p, // provider name
                                        c, // currency (in/out only: 2/3)
                                        ia, // incurred amount
                                        s, // status (in/out only: 2/3)
                                        tx, // transaction no. (in/out only: 2/3)
                                        vn, // visit number
                                        vd, // date of visit (panel/in: 1/2)
                                        ad, // admission date (out: 3)
                                        id,
                                        eid, // employee record id
                                        did, // dependant record id
                                        retry,

                                    } = claim;
                                    if (tx && (t === 2 || t === 3)) {
                                        return (
                                            <Table.Row key={tx}>
                                                <Table.Cell>
                                                    <Link to={(t === 3) ? `/app/claimrecords/out/${tx}` : `/app/claimrecords/inp/${tx}`}>
                                                        {vn} / {tx}
                                                    </Link>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <Link to={(t === 3) ? `/app/claimrecords/out/${tx}` : `/app/claimrecords/inp/${tx}`}>
                                                        {Moment((vd || ad), 'D/M/YYYY').format('DD MMM YYYY')}
                                                    </Link>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <ClaimStatusLabel status={s} />
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {p}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {typeOfClaimList[t]}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <Link to={`/app/askjoey?type=${ (t === 3)? `outclaim` : `inpclaim`}&id=${encodeURIComponent(tx)}`}>
                                                        <Button>
                                                            Ask Joey
                                                        </Button>
                                                    </Link>
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    }else if(id){
                                        return (
                                            <Table.Row key={id} className={retry >=3 ? "warning-text" : ""}>
                                                <Table.Cell>
                                                    <Link to={(t === 3) ? `/app/claimrecords/out/${id}/${s}` : `/app/claimrecords/inp/${id}/${s}`}>
                                                        {id}
                                                    </Link>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <Link to={(t === 3) ? `/app/claimrecords/out/${id}/${s}` : `/app/claimrecords/inp/${id}/${s}`}>
                                                        {Moment((vd || ad), 'D/M/YYYY').format('DD MMM YYYY')}
                                                    </Link>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <ClaimStatusLabel status={s} />
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {p}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {typeOfClaimList[t]}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <Link to={`/app/askjoey?type=${ (t === 3)? `outclaim` : `inpclaim`}&id=${encodeURIComponent(id)}`}>
                                                        <Button>
                                                            Ask Joey
                                                        </Button>
                                                    </Link>
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    }
                                })
                            }
                        </Table.Body>
                    </Table>
                </Segment>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        claimFilterOptions: state.claims.filterOptions,
        claims: state.claims.claims,
        inpatientClaims: state.claims.inpatientClaims,
        outpatientClaims: state.claims.outpatientClaims,
        claimsList: state.claims.data,
        isLoaded: state.claims.isLoaded,
        user: state.user.user,
        contactNoVerified: state.otp.contactNoVerified,
    };
}

export default connect(mapStateToProps, {
    getInpatientClaims,
    getOutpatientClaims,
    getAllClaims,
    getClaimOptionsEclaim,
    updateClaimFilterOptions,
    getClaimUserPlanConfigBenefit
})(ClaimRecordPage);
